import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopInstallmentInfoEditReservationDownloadResponse } from '@/repositories/generated';

const response: ShopInstallmentInfoEditReservationDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['削除フラグ', '外部企業ID', '外部店舗ID', '手数料区分', '支払区分', '分割払い 支払回数指定', 'ボーナス併用払い 支払回数指定', '適用開始日', '予約情報ステータス'],
  ]),
};

export const reservedSplitPaymentDownload = http.get(
  createMockEndpoint('/shop/download/reserved_split_payment'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
